const escapeHtml = value =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')

export const normalizeExternalUrl = value => {
  const raw = String(value || '').trim()
  if (!raw) throw new Error('Informe a URL do link.')
  if (/^javascript:/i.test(raw)) throw new Error('Links JavaScript não são permitidos.')

  const normalized = /^https?:\/\//i.test(raw) ? raw : 'https://' + raw
  const parser = document.createElement('a')
  parser.href = normalized

  if (!/^https?:$/i.test(parser.protocol) || !parser.hostname) {
    throw new Error('Informe uma URL HTTP ou HTTPS válida.')
  }

  return normalized
}

export const buildExternalHtmlLink = (text, url) => {
  const normalizedUrl = normalizeExternalUrl(url)
  const label = String(text || '').trim() || normalizedUrl

  return (
    '<a href="' +
    escapeHtml(normalizedUrl) +
    '" target="_blank" rel="noopener">' +
    escapeHtml(label) +
    '</a>'
  )
}

export const buildInternalHtmlLink = (text, contentId) => {
  const normalizedId = String(contentId || '').trim()
  const label = String(text || '').trim()

  if (!/^[a-f\d]{24}$/i.test(normalizedId)) {
    throw new Error('Selecione um conteúdo válido do Informed.')
  }
  if (!label) throw new Error('Informe o texto que aparecerá no link.')

  return (
    '<a class="link_interno" data-content data-href="' +
    escapeHtml(normalizedId) +
    '" href="#">' +
    escapeHtml(label) +
    '</a>'
  )
}




// WEBPACK FOOTER //
// ./src/utils/htmlLinkUtils.js